import { Menu, MenuButton, MenuItem, MenuList, Tag } from "@chakra-ui/react";
import React from "react";
import { BiChevronDown } from "react-icons/bi";
import { InvoiceStatus } from "types/invoice";

interface Props {
  status: InvoiceStatus;
  editable: boolean;
  callback?: any;
}

interface CustomTagProps {
  status: InvoiceStatus;
  clickable?: boolean;
}

const tagColor = (status: InvoiceStatus): string => {
  switch (status) {
    case InvoiceStatus.Paid:
      return "green";
    case InvoiceStatus.PastDue:
      return "red";
    case InvoiceStatus.Void:
      return "gray";
    case InvoiceStatus.Pending:
    default:
      return "yellow";
  }
};

const CustomTag: React.FC<CustomTagProps> = ({
  status,
  clickable
}: CustomTagProps) => {
  //console.log(status);
  return (
    <Tag
      variant="subtle"
      colorScheme={tagColor(Number(status))}
      size="lg"
      width="fit-content"
    >
      {InvoiceStatus[status]}
      {clickable && <BiChevronDown />}
    </Tag>
  );
};

const StatusTag: React.FC<Props> = ({
  status,
  editable = true,
  callback
}: Props) => {
  return editable ? (
    <Menu>
      <MenuButton width="fit-content">
        <CustomTag status={status} clickable />
      </MenuButton>
      <MenuList bg="gray.800">
        {Object.entries(InvoiceStatus)
          .filter(e => !isNaN(Number(e[0])) && e[1] !== InvoiceStatus[status])
          .map(item => (
            <MenuItem
              sx={{ _hover: { bg: "gray.700" }, _focus: { bg: "gray.700" } }}
              key={item[1]}
              onClick={() => callback(item[0])}
            >
              {item[1]}
            </MenuItem>
          ))}
      </MenuList>
    </Menu>
  ) : (
    <CustomTag status={status} />
  );
};

export default StatusTag;
